import AlternateGameAlert from "./alternate-game-alert";
import TournamentBuyBox from "../containers/tournament-buy-box";
import { getLargeBadges } from "../badges";
import LightBox from "./light-box";
import LiveBankrollNotification from "./live-bankroll-notification";
import React from "react";

export default class EnterTournamentLightbox extends React.PureComponent {
  constructor(props) {
    super(props);
    var { tournament } = this.props;
    this.state = { allowEntry: !tournament.get("real_money") };
    this.toggleAllowEntry = this.toggleAllowEntry.bind(this);
  }

  toggleAllowEntry() {
    var { allowEntry } = this.state;
    this.setState({ allowEntry: !allowEntry }); // eslint-disable-line react/no-set-state
  }

  render() {
    var { communications, isGameBoard, onClose, session, tokenTypes, tournament } = this.props;
    var { allowEntry } = this.state;

    if (session.get("showLogin") || communications.getIn(["sessionCreate", "state"]) === "in progress") {
      return null;
    }

    var disclaimer;
    if (tournament.get("real_money")) {
      disclaimer = (<LiveBankrollNotification
        accepted={allowEntry}
        onToggleAcceptance={this.toggleAllowEntry}
        session={session}
        tournament={tournament} />);
    }

    return (
      <LightBox onClose={onClose} small title="Enter Tournament">
        <div className="lightbox_body">
          <h3>
            {tournament.get("name")}
          </h3>

          {disclaimer}

          <TournamentBuyBox
            disabled={!allowEntry}
            isGameBoard={isGameBoard}
            tournament={tournament} />

          <div className="tournament-table_badges_container">
            {getLargeBadges(tournament, true, true)}
          </div>

          <AlternateGameAlert tokenTypes={tokenTypes} tournament={tournament} />
        </div>
      </LightBox>
    );
  }
}
